import { render, staticRenderFns } from "./GreyContactBox.vue?vue&type=template&id=bde62f7c&scoped=true"
import script from "./GreyContactBox.vue?vue&type=script&lang=js"
export * from "./GreyContactBox.vue?vue&type=script&lang=js"
import style0 from "./GreyContactBox.vue?vue&type=style&index=0&id=bde62f7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde62f7c",
  null
  
)

export default component.exports